// Route: '/login'
import React, { useState } from 'react';
import styles from './LoginPage.module.css';
import { PrimaryButton } from '../../components/Buttons/Buttons';
import Nav from '../../components/Nav/Nav';
import PasswordInput from '../../components/PasswordInput/PasswordInput';
import TextInput from '../../components/TextInput/TextInput';
import { Link, Redirect, useHistory } from 'react-router-dom';
import API from '../../utils/api';

const LoginPage = () => {
  const [emailInput, setEmailInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const [message, setMessage] = useState('');
  const [messageError, setMessageError] = useState(false);
  const history = useHistory();
  const api = new API('http://8.140.23.228');

  // api call functions
  const login = async () => {
    const response = await api.makeAPIRequest('admin/auth/login', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: emailInput,
        password: passwordInput,
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        localStorage.setItem('token', json.token);
        setMessageError(false);
        setMessage('');
        history.push('/');
      } else {
        setMessageError(true);
        setMessage(json.error);
      }
    } catch (e) {
      console.log('ERROR', e);
      setMessageError(true);
      setMessage('Sorry! Can\' connect to the server.');
    }
  };

  if (localStorage.getItem('token')) {
    return <Redirect to='/' />
  }

  return (
    <section>
      <Nav visibilities={['true', 'true', 'false', 'false', 'false']} />
      <div className={styles.main}>
        <h2>Log in</h2>
        <TextInput
          name='email'
          label="Email"
          value={emailInput}
          onChange={e => setEmailInput(e.target.value)}
        />
        <PasswordInput
          name='password'
          value={passwordInput}
          onChange={e => setPasswordInput(e.target.value)}
        />
        <PrimaryButton
          label='login-button'
          animated
          className={styles.button}
          onClick={login}
        >
          <span>Log in</span>
        </PrimaryButton>
        <p className={styles[messageError ? 'error' : 'message']}>{message}</p>
        <p>
          Don&apos;t have an account? <Link to='/register'>Sign up</Link>
        </p>
      </div>
    </section>
  );
};

export default LoginPage;
